// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"ListableRulesItem_checkbox__1CozA","icon":"ListableRulesItem_icon__1Rx7_"};